// extracted by mini-css-extract-plugin
export default {"modalOverlay":"XB-z","modalContent":"YB-z","header":"ZB-z","close":"_B-z"};